export default "__VITE_ASSET__DZWOnxu7__"